import toKebabCase from './toKebabCase';

export default (...attributes) => (el) =>
  attributes.forEach((attribute) => el.removeAttribute(toKebabCase(attribute)));
